// extracted by mini-css-extract-plugin
export default {"extendedButton":"AttachFromGoogleDriveButton_extendedButton__4Hwh8","mobileButton":"AttachFromGoogleDriveButton_mobileButton__nmQFs"};